<script>
	import { fade } from 'svelte/transition'
	import Toggle from './Toggle.svelte'

	export let path = ''

	let active_tab = 'interior'
	let active = {
		interior: 'black',
		exterior: 'beige'
	}
	
	const items = {
		exterior: [
			['<p class="kolor">Kość słoniowa</p><p>(RAL1015)</p>', 'beige'],
			['<p class="kolor">Żółty sygnałowy</p><p>(RAL1023)</p>', 'yellow'],
			['<p class="kolor">Pomarańczowy</p><p>(RAL2004)</p>', 'orange'],
			['<p class="kolor">Purpurowy</p><p>(RAL3004)</p>', 'red-dark'],
			['<p class="kolor">Czerwony</p><p>(RAL3020)</p>', 'red'],
			['<p class="kolor">Ultramaryna</p><p>(RAL5002)</p>', 'blue'],
			['<p class="kolor">Niebieski ciemny</p><p>(RAL5022)</p>', 'blue-dark'],
			['<p class="kolor">Zielony mchowy</p><p>(RAL6005)</p>', 'green-dark'],
			['<p class="kolor">Zielony</p><p>(RAL6024)</p>', 'green'],
			['<p class="kolor">Szary antracytowy</p><p>(RAL7016)</p>', 'grey-dark'],
			['<p class="kolor">Szary</p><p>(RAL7042)</p>', 'grey'],
			['<p class="kolor">Brązowy orzechowy</p><p>(RAL8011)</p>', 'brown'],
			['<p class="kolor">Czarny</p><p>(RAL9005)</p>', 'black'],
			['<p class="kolor">Jasne aluminium</p><p>(RAL9006)</p>', 'grey-old'],
			['<p class="kolor">Biały drogowy</p><p>(RAL9016)</p>', 'milk'],
			['<p class="kolor">Szczotkowane srebro</p>', 'brushed-silver'],
			['<p class="kolor">Szczotkowane złoto</p>', 'cooper-brushed-gold'],
			['<p class="kolor">Szczotkowana czerń</p>', 'cooper-brushed'],
			['<p class="kolor">Biały</p>', 'white'],
			['<p class="kolor">Lustrzany złoty</p>', 'gold-mirror'],
			['<p class="kolor">Lustrzany srebrny</p>', 'silver-mirror']
		],
		interior: [
			['<p>Czarny</p>', 'black'],
			['<p>Niebieski</p>', 'blue'],
			['<p>Jasny niebieski</p>', 'blue-light'],
			['<p>Ciemny niebieski</p>', 'blue-dark'],
			['<p>Brązowy</p>', 'brown'],
			['<p>Ciemno szary</p>', 'grey-dark'],
			['<p>Jasno szary</p>', 'grey'],
			['<p>Zielony</p>', 'green'],
			['<p>Ciemno czerwony</p>', 'red-dark'],
			['<p>Czerwony</p>', 'red'],
			['<p>Fioletowy</p>', 'violet'],
			['<p>Żółty</p>', 'yellow']
		]
	}
	const labels = [
		{ text:'Kolor wnętrza', color: 'var(--darker)' },
		{ text:'Kolor obudowy', color: 'var(--darker)' }
	]
	const handleToggle = e => {
		active_tab = Object.keys(active)[e.detail]
	}
</script>


<div class="wrapper">
	<div class="preview">
		{#key active.interior}
			<img transition:fade src="{path}images/interior/preview-color-{active.interior}.png" alt="{active.interior}" class="absolute">
		{/key}
		{#key active.exterior}
			<img transition:fade src="{path}images/exterior/preview-color-{active.exterior}.png" alt="{active.exterior}" class="absolute">
		{/key}
	</div>
	<div class="selector">
		<Toggle {labels} on:toggle={handleToggle} />
		<div style="margin: 1em"></div>
		<div class="options" transition:fade|local>
				{#each items[active_tab] as option}
					<div
						class="option-wrapper"
						on:click={() => active[active_tab] = option[1]}
					>
						<img
							src="{path}images/{active_tab}/control-color-{option[1]}.png"
							alt="{option[1]}"
							class:active={active[active_tab] === option[1]}
						>
						<div class="opis">
							{@html option[0]}
						</div>
					</div>
				{/each}
				{#if active_tab === 'exterior'}
					<div class="option-wrapper"></div>
					<div class="option-wrapper"></div>
					<div class="option-wrapper"></div>
				{/if}
		</div>
	</div>
</div>

<style>
	.wrapper {
	    display: flex;
	    width: 100%;
	}

	.preview {
		position: relative;
	    width: 100%;
	    min-height: 540px;
	}

	.absolute {
	    position: absolute;
	}
	.active {
		font-weight: bold;
	}

	.options {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
	}
	.option-wrapper {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
		width: calc(100% / 6);
		text-align: center;
		margin-bottom: 0.618em;
	}
	.option-wrapper img {
		width: 74px;
		height: 74px;
		padding: 5px;
		cursor: pointer;
	}
	.option-wrapper img.active {
		border: 3px solid var(--darker);
		border-radius: 50%;
	}
	.option-wrapper .opis {
		margin: 0;
		flex: 1;
		margin-top: 5px;
	}
	:global(.option-wrapper .opis p) {
		margin: 0;
		flex: 1;
		line-height: 1;
		text-align: center;
	}
	:global(.option-wrapper p.kolor) {
		margin-bottom: 5px;
	}
	.selector {
		width: 100%;
	}
@media (max-width: 888px) {
	.wrapper {
		display: block
	}
	.preview {
		position: relative;
	    width: 100%;
	    min-height: unset;
	    margin-top: 100%;
	}
	.preview img {
		width: 100%;
		margin-top: -100%;
	}
}
@media (max-width: 1099px) {
	.option-wrapper {
		width: calc(100% / 3);
	}
}
</style>